/* START SHIPPING CARRIER SERVICE PRE-SETTER BY INNOVATE */ // Line 297 initializer
const API_BASE_URL = 'https://shipping-honduras.appkalea.com'
const MARKER_IMAGE_URL = 'https://cdn.shopify.com/s/files/1/0631/2827/3126/files/map_marker_-_kalea.png?v=1663258166'
const municipalityDefault = '<option selected disabled>Seleccione un departamento primero</option>'
const neighborhoodDefault = '<option selected disabled>Seleccione un municipio primero</option>'
const mapId = 'cartShippingMap'
let cartMap
let placeSearchInstance
let SHIPPING_DATA = []
let DEPARTMENTS = []
let carrierTypeSelect
let prodAssemblingSelect
let departmentSelect
let municipalitieSelect
let neighborhoodSelect
let checkoutButton
let totalCartSpan
let cartSection
let estimateShippingBox
let cartNotesText
let selectMarkerZoneBtn
let cartMarker

// Init lat & lng with Honduras centered position
const mapConfig = {
    position: {
        lat: 15.2241819,
        lng: -87.3304803
    },
    zoom: 7
}

const shippingState = {
    type: '',
    depto: '',
    municipality: '',
    neighborhood: '',
    assembling: ''
}

const carrierData = {
    _depto: shippingState.depto,
    _municipality: shippingState.municipality,
    _neighborhood: shippingState.neighborhood,
    _userLat: mapConfig.position.lat,
    _userLng: mapConfig.position.lng,
    _userImage: null
}

const createDraggableMarker = () => {
    const centerMap = cartMap.getCenter()
    const thisPosition = { lat: centerMap.lat(), lng: centerMap.lng() }

    if ( cartMarker ) {
        cartMarker.setPosition(thisPosition)
        return
    }

    cartMarker = new google.maps.Marker({
        position: thisPosition,
        map: cartMap,
        draggable: true,
        icon: MARKER_IMAGE_URL
    })

    cartMarker.addListener('dragend', () => {
        const markerCenter = cartMarker.getPosition()
        carrierData._userLat = markerCenter.lat()
        carrierData._userLng = markerCenter.lng()
        const latLng = `${carrierData._userLat},${carrierData._userLng}`

        carrierData._userImage = `https://maps.googleapis.com/maps/api/staticmap?center=${latLng}&zoom=${cartMap.getZoom()}&size=1280x720&key=${window.MAPS_API_KEY}&markers=icon:${MARKER_IMAGE_URL}|${latLng}`
    })
}

const updateMapPosition = ( latLngPair ) => {
    const { lat, lng } = latLngPair
    mapConfig.position = { lat, lng }
    mapConfig.zoom = latLngPair.zoom || 8

    cartMap.setZoom(mapConfig.zoom)
    cartMap.panTo(mapConfig.position)
}

const findPlaceByQuery = ( placeQuery, zoom ) => {
    placeSearchInstance.textSearch({ query: placeQuery}, (results, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && results) {
            updateMapPosition({
                lat: results[0].geometry?.location.lat(),
                lng: results[0].geometry?.location.lng(),
                zoom
            })
        }
    })
}

const initializeIntegration = async () => {
    cartSection = document.querySelector('section[data-section-id="cart-template"]')
    if ( cartSection.querySelector('.cart-wrapper') ) {
        // carrierTypeSelect     = document.getElementById('carrier-service-type')
        departmentSelect      = document.getElementById('carrier-service-department')
        municipalitieSelect   = document.getElementById('carrier-service-municipality')
        neighborhoodSelect    = document.getElementById('carrier-service-neighborhood')
        // prodAssemblingSelect  = document.getElementById('carrier-service-assembling')
        checkoutButton        = document.querySelector('button[name="checkout"]')
        totalCartSpan         = document.querySelector('.cart-recap__price-line-price')
        estimateShippingBox   = document.querySelector('.estimate-shipping')
        cartNotesText         = document.querySelector('textarea[name="note"]')
        selectMarkerZoneBtn   = document.querySelector('[data-select-shipping-place]')
        await retrieveShippingInfo()
        setCallbacks()
    }
}

const retrieveShippingInfo = async () => {
    try {
        const request = await fetch(`${API_BASE_URL}/carrier-service/properties`)
        const response = await request.json()
        SHIPPING_DATA = response
        DEPARTMENTS = Array.from(new Set(response.map( elem => elem.depto ))) // Setting the distinct departments to be listed on the select
        renderDepartments()
    } catch (err) {
        console.log(err)
    }
}

const renderDepartments = () => {
    let options = '<option selected disabled>Escoge departamento</option>'
    options += DEPARTMENTS.map( depto => `<option value="${depto}">${depto}</option>`)
    departmentSelect.innerHTML = options
}

const renderMunicipalities = () => {
    let options = '<option selected disabled>Escoge municipio</option>'
    let municipalities = SHIPPING_DATA.filter(elem => elem.depto === shippingState.depto)
    municipalities = [...new Set(municipalities.map(x => x.municipality))]
    options += municipalities.map(municipality => `<option value="${municipality}">${municipality}</option>`)
    municipalitieSelect.innerHTML = options
}

const renderNeighborhoods = () => {
    let options = '<option selected disabled>Escoge barrio</option>'
    let neighborhoods = SHIPPING_DATA.filter(elem =>
        elem.depto === shippingState.depto &&
        elem.municipality === shippingState.municipality
    ).sort((a, b) => a.neighborhood.charAt(0) > b.neighborhood.charAt(0) ? 1 : -1 )

    options += neighborhoods.map(x => `<option value="${x.neighborhood}">${x.neighborhood}</option>`)
    neighborhoodSelect.innerHTML = options
}

const setCallbacks = () => {
    departmentSelect.addEventListener('change', (evt) => {
        resetMunSelect()
        resetNeighSelect()
        shippingState.depto = evt.target.value
        renderMunicipalities()
        shippingState.municipality = ''
        shippingState.neighborhood = ''
        findPlaceByQuery(`${shippingState.depto}, Honduras`, 12)
    })

    municipalitieSelect.addEventListener('change', (evt) => {
        shippingState.municipality = evt.target.value
        shippingState.neighborhood = ''
        resetNeighSelect()
        renderNeighborhoods()
        findPlaceByQuery(`${shippingState.municipality}, ${shippingState.depto}, Honduras`, 12)
    })

    neighborhoodSelect.addEventListener('change', async (evt) => {
        shippingState.neighborhood = evt.target.value

        carrierData._depto = shippingState.depto
        carrierData._municipality = shippingState.municipality
        carrierData._neighborhood = shippingState.neighborhood

        await updateFirstItemProperties(carrierData)
        findPlaceByQuery(`${shippingState.neighborhood}, ${shippingState.municipality}, ${shippingState.depto} Honduras`, 15)
    })

    selectMarkerZoneBtn.addEventListener('click', createDraggableMarker)

    checkoutButton.addEventListener('click', checkoutButtonCallback)

    window.addEventListener('removeCheckoutButtonListener', () => {
        checkoutButton.removeEventListener('click', checkoutButtonCallback)
        checkoutButton.click()
    })
}

const updateFirstItemProperties = async ( carrierDataObj ) => {
    try {
        const firstItemId = $Innovate.$Cart.state.items[0].id
        const cart = await $Innovate.$Cart.get()
        const item = $Innovate.$Cart.state.items.find(x => x.id === firstItemId)

        const request = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: item.key,
              quantity: item.quantity,
              properties: carrierDataObj
            })
        })
        const response = await request.json()
        // await $Innovate.$Cart.items[firstItemId].addProperties(carrierDataObj)
    } catch (err) {
        console.log(err)
    }
}

const updateDomData = () => {
    const newCart = $Innovate.$Cart.state
    totalCartSpan.textContent = `Q${(newCart.total_price / 100).toFixed(2)}`

    if ( newCart.items.length > 0 ) {
        newCart.items.forEach( item => {
            const relRowPriceDiv = document.querySelector(`.line-item__line-price[data-variant-id="${item.id}"]`)
            if ( relRowPriceDiv ) relRowPriceDiv.innerHTML = `<span>Q${((item.price*item.quantity)/100).toFixed(2)}</span>`
        })
    } else {
        location.reload()
    }
}

const checkoutButtonCallback = async (evt) => {
    evt.preventDefault()
    evt.stopPropagation()
    evt.stopImmediatePropagation()

    const [...qtyInputs] = document.querySelectorAll('.quantity-selector__value')
    const propsFirstItem = $Innovate.$Cart.state.items[0].properties
    const errors = []
    const ERROR_TYPES = {
        type: 'Debe seleccionar el tipo de envío',
        assembling: 'Debe seleccionar el estado del producto para el retiro',
        depto: 'Seleccione departamento',
        municipality: 'Seleccione municipio',
        neighborhood: 'Seleccione barrio',
        noStock: 'Al parecer no hay mas stock para tu producto, intenta mas tarde'
    }

    const fieldsToCheck = [departmentSelect, municipalitieSelect, neighborhoodSelect]

    fieldsToCheck.forEach( field => {
        if ( shippingState[field.name] === '' ) {
            if ( errors.length === 0 ) {
                field.setCustomValidity(ERROR_TYPES[field.name])
                field.reportValidity()
            }
            errors.push(ERROR_TYPES[field.name])
        } else field.setCustomValidity('')
    })

    if ( errors.length > 0 ) return

    await updateFirstItemProperties(carrierData)
    window.dispatchEvent( new Event('removeCheckoutButtonListener') )
}

const resetMunSelect = () => municipalitieSelect.innerHTML = municipalityDefault
const resetNeighSelect = () => neighborhoodSelect.innerHTML = neighborhoodDefault

document.addEventListener('DOMContentLoaded', initializeIntegration)
document.addEventListener('cart:rerendered', () => {
    const newShippingBox = document.querySelector('.estimate-shipping');
    newShippingBox.parentElement.prepend(estimateShippingBox)
    newShippingBox.remove()
})

window.initCartMap = () => {
    cartMap = new google.maps.Map(document.getElementById(mapId), {
        center: mapConfig.position,
        zoom: mapConfig.zoom,
    });

    placeSearchInstance = new google.maps.places.PlacesService(cartMap)
}
/* END CARRIER SERVICE PRE-SETTER BY INNOVATE */
